import { IdFormat } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->
  { className } = IdFormat
  configNode = new Weaver.Node(className)
  configNode.set('name', className)
  await configNode.save({ transaction, branch, commitMessage: "Add Id Format Migration." })
  idFormat = new IdFormat()
  idFormat.setIdType('uuid', { transaction, branch })
  await idFormat.save({ transaction, branch })
